module.exports = __webpack_public_path__ + "img/are-you-sure.c5a124d8.svg";